import { render, staticRenderFns } from "./DetailPageLayout.vue?vue&type=template&id=223f5d12&scoped=true&"
import script from "./DetailPageLayout.vue?vue&type=script&lang=ts&"
export * from "./DetailPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPageLayout.vue?vue&type=style&index=0&id=223f5d12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f5d12",
  null
  
)

export default component.exports